"use client";

import { createContext } from 'react';
var MotionContext = createContext({});
export { MotionContext };